import React from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import { People, CheckCircle } from "@mui/icons-material";
import { useBlastCampaign } from "../../context";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const PreviewCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
  border-radius: 12px;
  background: ${(props) => props.theme.colors?.background || "#FFFFFF"};
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: ${(props) => props.theme.colors?.primaryLight || "#EFF6FF"};
  color: ${(props) => props.theme.colors?.primary || "#3B82F6"};

  svg {
    width: 24px;
    height: 24px;
  }
`;

const Info = styled.div`
  flex: 1;
`;

const Title = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.colors?.text || "#111827"};
  margin: 0 0 4px 0;
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
  margin: 0;
`;

const Badge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  background: ${(props) => props.theme.colors?.successLight || "#D1FAE5"};
  color: ${(props) => props.theme.colors?.success || "#059669"};
  font-size: 14px;
  font-weight: 500;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const ContactsPreview = observer(() => {
  const { blastContacts, contactSource } = useBlastCampaign();

  if (!blastContacts.length) {
    return null;
  }

  const sourceLabel = contactSource === "csv" ? "from CSV" : "from database";

  return (
    <Container>
      <PreviewCard>
        <IconWrapper>
          <People />
        </IconWrapper>
        <Info>
          <Title>Contacts Ready</Title>
          <Subtitle>
            {blastContacts.length} contact{blastContacts.length !== 1 ? "s" : ""}{" "}
            selected {sourceLabel}
          </Subtitle>
        </Info>
        <Badge>
          <CheckCircle />
          Ready
        </Badge>
      </PreviewCard>
    </Container>
  );
});

export default ContactsPreview;
